import { getMainTheme as getBaseTheme, Themes } from '@ankr.com/ui';
import { createTheme } from '@mui/material/styles';

import { featureConfig } from 'modules/common/featureConfig';

import { lightTheme, darkTheme } from './tokens';
import IndeterminateCheckboxIcon from './assets/indeterminateCheckboxIcon.svg?react';

const isBlockrailTheme = featureConfig.isBlockrailTheme;
const themeMode = isBlockrailTheme ? 'blockrail' : 'ankr';

export const getMainTheme = (themes: Themes) => {
  const baseTheme = getBaseTheme(themes, themeMode);

  const tokenTheme = themes === Themes.light ? lightTheme : darkTheme;

  return createTheme({
    ...baseTheme,
    // Take color tokens from local tokenTheme
    palette: tokenTheme.palette,
    components: {
      ...baseTheme.components,
      MuiPaper: {
        ...baseTheme.components?.MuiPaper,
        styleOverrides: {
          ...baseTheme.components?.MuiPaper?.styleOverrides,
          root: {
            // @ts-ignore
            ...baseTheme.components?.MuiPaper?.styleOverrides?.root,
            backgroundImage: 'none',
            ...((baseTheme.components?.MuiPaper?.styleOverrides?.root as
              | Record<string, unknown>
              | undefined) || {}),
          },
        },
      },
      MuiCheckbox: {
        ...baseTheme.components?.MuiCheckbox,
        defaultProps: {
          ...baseTheme.components?.MuiCheckbox?.defaultProps,
          indeterminateIcon: <IndeterminateCheckboxIcon />,
        },
        styleOverrides: {
          ...baseTheme.components?.MuiCheckbox?.styleOverrides,
          indeterminate: {
            '--indeterminate-checkbox-background':
              tokenTheme.palette.primary?.main,
            '--indeterminate-checkbox-sign':
              tokenTheme.palette.background?.paper,

            '&:hover': {
              '--indeterminate-checkbox-background':
                tokenTheme.palette.primary?.dark,
            },

            '&.Mui-disabled': {
              '--indeterminate-checkbox-background': tokenTheme.palette.divider,
              '--indeterminate-checkbox-sign':
                tokenTheme.palette.text?.disabled,
            },
          },
        },
      },
    },
  });
};

export const mainTheme = getMainTheme(Themes.light);
